import React from "react";
import Loading from "src/components/Loading";
import { getSection } from "src/hooks/useContentful/getSection";
import { useFetchContent } from "src/hooks/useContentful/useFetchContent";
import { CustomButtom } from "../../../../components/BotaoCTA/styles";
import * as S from "./style";
import { eventTrack } from "src/components/GoogleTagManager";
import { slugfy } from "src/utils/formatters";

export default function TagVeloe() {
  const scrollToOffer = () => {
    const el = document.querySelector("#plans");
    const yOffset = -120;
    const y = el.getBoundingClientRect().top + window.pageYOffset + yOffset;

    window.scrollTo({ top: y, behavior: "smooth" });
  };

  const { data, isLoading } = useFetchContent();
  const {
    titulo,
    titleColor,
    corDeFundo,
    corDoBotao,
    corDoTextoDoBoto,
    botao,
    tag,
  } = getSection({
    sectionName: "landingSecaoTagVeloe",
    data,
  });

  const { file, title } = tag.fields;

  if (isLoading || !data) return <Loading />;
  return (
    <S.Container style={{ backgroundColor: corDeFundo }}>
      <S.Image src={`https://${file.url}`} alt={title} />
      <S.Content>
        <S.Title color={titleColor}>{titulo}</S.Title>
        <S.ButtonWrapper>
          <CustomButtom
            className="botaoTagVeloe"
            color="primary"
            label={botao}
            onClick={() => {
              scrollToOffer();
              eventTrack(
                "veloe:institucional",
                "clique:botao",
                "tag-veloe:" + slugfy(botao)
              );
            }}
            style={{
              backgroundColor: corDoBotao,
              color: corDoTextoDoBoto,
            }}
          />
        </S.ButtonWrapper>
      </S.Content>
    </S.Container>
  );
}
